<template>
  <div
    :class="`fileMarket${label ? '' : ' d-flex align-center'}`"
    v-if="items.length !== 0"
  >
    <p
      :class="`d-flex align-center mb-0${center}`"
      v-for="item in items"
      :key="item"
    >
      <img
        :class-name="'market-mini-svg js-img'"
        :style="`width:${size}px; height:${size}px;`"
        :src="require(`@/assets/images/market_${ item.toLowerCase() }.svg`)"
        :class="{ 'mr-1': spacing }"
      />
      <span class="ml-1 mb-0" v-if="label">
        {{ getItem(item)[`name_${$i18n.locale.split('-')[0]}`] }}
      </span>
    </p>
  </div>
</template>
<script>
export default {
  name: 'iconMarkets',
  data() {
    return {
      datas: [],
      dico: [ "AL", "GL", "WL", "IL", "FL" ],
    }
  },
  props: {
    items: {
      type: Array,
      default: () => []
    },
    size: {
      type: Number,
      default: 40
    },
    label: {
      type: Boolean,
      default: false
    },
    center: {
      type: String,
      default: ""
    },
    spacing: {
      type: Boolean,
      default: true
    }
  },
  mounted () {
    this.sortItems()
  },
  destroy () {
    this.datas = []
    this.items = []
  },
  // computed: {
  //   marginBetween () {
  //     return this.spacing ? "mr-1" : null;
  //   }
  // },
  methods: {
    sortItems () {
      if (this.items.length !== 0) {
        this.datas = this.items.sort((a, b) => this.dico.indexOf(a) - this.dico.indexOf(b))
      }
    },

    getItem (value) {
      const items = this.$store.getters["home/termsType"]('markets')
      return items.filter(f => f.key === value.toUpperCase())[0]
    },
  }
}
</script>
